import { ref } from '@vue/composition-api'
import { STORE_MODULE_NAME } from "./platformStoreModule";

export default function usePlatform() {

    // Table Handlers
  const tableColumns = ref([
      { key: 'platform',
        label: 'платформа',
      },
      { key: 'station',
        label: 'станция',
      },
      { key: 'user',
        label: 'пользователь',
      },
  ])

  const setupData = {
      formModel: {
          number: '',
          object_type:'',
          station: '',
          user: '',
      },
  }

  const addDataUrl = `${STORE_MODULE_NAME}/create`
  const fetchDataUrl = `${STORE_MODULE_NAME}/fetch`

  return {

    addDataUrl,
    fetchDataUrl,

    tableColumns,
    setupData,
  }
}
